import React from 'react';
import ImportReviewDetails from './ImportReviewDetails';
import ImportReviewIntegrationSettings from './ImportReviewIntegrationSettings';

const ImportReviewMainContent: React.FC = () => (
  <div className="w-3/5 pr-10 h-full flex flex-col gap-1 text-body bg-white">
    <div className="h-full flex flex-col gap-8">
      <span>Review selections</span>

      <div className="h-full flex flex-col gap-8">
        <ImportReviewDetails />
        <ImportReviewIntegrationSettings />
      </div>
    </div>
  </div>
);

export default ImportReviewMainContent;
